import { render, staticRenderFns } from "./basicDetails.html?vue&type=template&id=751849f2&scoped=true&external"
import script from "./basicDetails.vue?vue&type=script&lang=js"
export * from "./basicDetails.vue?vue&type=script&lang=js"
import style0 from "./basicDetails.css?vue&type=style&index=0&id=751849f2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751849f2",
  null
  
)

export default component.exports